import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faRedo } from "@fortawesome/free-solid-svg-icons"

export const Redo = (props) => {
  return <FontAwesomeIcon faIcon={faRedo} {...props} />
}
